import { cn } from "cn";
import type * as React from "react";

/**
 * The ROSC mark with the wordmark, as in the v3.2 sidebar: the blue app
 * mark and "ROSC" in the display face. `size` is the mark's edge in px.
 * `src` is the mark's URL in the host app (apps/web serves it from
 * /images/logos/logo.svg).
 */
export function Logo({
  src,
  size = 28,
  wordmark = true,
  className,
}: {
  src: string;
  size?: number;
  wordmark?: boolean;
  className?: string;
}): React.JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 font-v3 text-v3-text",
        className,
      )}
      data-testid="v3-logo"
    >
      <img
        alt={wordmark ? "" : "ROSC"}
        height={size}
        src={src}
        style={{ width: size, height: size }}
        width={size}
      />
      {wordmark && (
        <span
          className="font-v3-display font-semibold tracking-tight"
          style={{ fontSize: Math.round(size * 0.62) }}
        >
          ROSC
        </span>
      )}
    </span>
  );
}
